(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.factory('encryptionService', ["http", "$q", "modals", "brandInfo", "loadingModal", function (http, $q, modals, brandInfo, loadingModal) {
        var encryptionService = {
            getEncryptionStatus: function () {
                return http.get('/api/v1/office365_emails/encryption/status');
            },
            createEncryptionRule: function () {
                return http.post('/api/v1/office365_emails/encryption/create_rule').run().then(function (res) {
                    if (res && res.data) {
                        return $q.when({ data: true });
                    }
                    return $q.reject({ data: { message: 'Can\'t create encryption rule!' } });
                }, function () {
                    return $q.reject({ data: { message: 'Can\'t create encryption rule.' } });
                });
            },
            retryCreateEncryptionRule: function (msg) {
                // msg coming from error response of policy save api
                var topMsg = (msg || 'We could not connect to your Office 365 account.<br>' + brandInfo.getBrandLabel() + ' requires PowerShell access in order to automatically configure the needed mail' + ' flow settings in your Exchange admin center.') + ('<br>If multi-factor authentication (MFA) is enabled in your organization for administrator users, ' + 'please specify the username of a global admin in your organization and an app password for this user.' + '<br>For help generating an app password, ' + '<a href="https://support.office.com/en-us/article/create-an-app-password-for-office-365-3e7c860f-bda4-4441-a618-b53953ee1183" ' + 'target="_blank">click here</a>.');
                var modalParams = [
                    {
                        sentence: '#' + JSON.stringify({
                            text: topMsg,
                            display: 'html'
                        }),
                        class: 'about-app-creation'
                    },
                    {
                        id: 'username',
                        type: 'string',
                        label: 'Admin username',
                        validation: { required: { message: 'User name can not be empty' } },
                        labelClass: 'o365-mfa-username-label',
                        paramClass: 'o365-mfa-username-param'
                    },
                    {
                        id: 'password',
                        type: 'password',
                        label: 'App password',
                        validation: { required: { message: 'Password can not be empty' } },
                        labelClass: 'o365-mfa-password-label',
                        paramClass: 'o365-mfa-password-param',
                        showPassword: true
                    }
                ];
                var modalTitle = 'Office 365 - Create Encryption Rule';
                return modals.params([{
                        lastPage: true,
                        defaultBtnLabel: 'Cancel',
                        params: modalParams
                    }], modalTitle, 'md', {
                    keyboard: false,
                    windowClass: 'o365-mfa-modal-container',
                    showError: true,
                    onCloseAction: function (data) {
                        var postData = {
                            username: data.username,
                            password: data.password,
                            save_mfa_info: true
                        };
                        return http.post('/api/v1/o365emails_verify_password').body(postData).run().then(function (res) {
                            if (res && res.data && res.data.status === 'ok') {
                                return $q.when({ data: { message: 'User verification success!' } });
                            } else {
                                return $q.reject({ data: { message: 'Please re-enter credentials and try again or contact Avanan support.' } });
                            }
                        }, function (err) {
                            return $q.reject({ data: { message: 'Please re-enter credentials and try again or contact Avanan support.' } });
                        });
                    }
                });
            }
        };
        return encryptionService;
    }]);
}());